export const PROVIDER_ROLES = ['therapist', 'psychiatrist', 'prescriber', 'coach'] as const

export type ProviderRole = (typeof PROVIDER_ROLES)[number]

export const normalizeProviderRole = (role?: string | null): ProviderRole | undefined => {
  const normalizedRole = role?.replace(/^lyra/i, '').replace(/_/g, ' ').trim().toLowerCase()
  return PROVIDER_ROLES.find((providerRole) => normalizedRole?.includes(providerRole))
}
